<template>
  <div>
      <monitoring-cluster-selection
          v-if="cluster && cluster.length > 0"
          :cluster="cluster"
          :label="clusterSelectionLabel"
          v-model="selectedClusterId"
      ></monitoring-cluster-selection>

    <div class="form-group checkboxes monitoring-monitoring-groups">
      <label for="interval" class="control-label">
        {{ labelGroupSelection }}
      </label>

      <div>
        {{ descriptionGroupSelection }}
        <br><br>
      </div>

      <div>
        <div class="pull-right">
          <a
              :href="linkToGroupManagement"
              class="btn btn-sm btn-primary"
          >
            {{ labelLinkToGroupManagement }}
          </a>
        </div>

        <div>
          <span>
            <input
                type="checkbox"
                name="all_friends"
                value="1"
                v-model="allFriends"
                class="update-monitoring-chart"
            >
            {{ labelAllFriends }}
          </span>

          <span>
            <monitoring-group-selection
                :cluster="selectedClusterObject"
            ></monitoring-group-selection>
          </span>

          <span>
            <input
                type="checkbox"
                name="new_friends"
                value="1"
                v-model="newFriends"
                class="update-monitoring-chart"
            >
            {{ labelNewFriends }}
          </span>

          <span>
            <input
                type="checkbox"
                name="casual_friends"
                value="1"
                v-model="casualFriends"
                class="update-monitoring-chart"
            >
            {{ labelCasualFriends }}
          </span>
        </div>
      </div>
    </div>

    <monitoring-group-overview
        :cluster="selectedClusterObject"
        :number-groups-label="numberGroupsLabel"
        :expand-label="expandLabel"
        :exclude-from-all-friends-label="excludeFromAllFriendsLabel"
        :yes-label="yesLabel"
        :no-label="noLabel"
        :label="groupOverviewLabel"
        :new-friends-description="newFriendsDescription"
    ></monitoring-group-overview>
  </div>
</template>

<script>
import MonitoringClusterSelection from "./MonitoringClusterSelection.vue";
import MonitoringGroupSelection from "./MonitoringGroupSelection.vue";
import MonitoringGroupOverview from "./MonitoringGroupOverview.vue";

export default {
  name: "MonitoringGroupManager",

  components: {
    MonitoringClusterSelection,
    MonitoringGroupSelection,
    MonitoringGroupOverview
  },

  props: {
    cluster: {
      type: Array,
      required: true
    },
    clusterGroups: {
      type: [Array, Object, null],
      required: true
    },
    numberGroupsLabel: {
      type: String,
      default: ''
    },
    expandLabel: {
      type: String,
      default: 'Expand'
    },
    excludeFromAllFriendsLabel: {
      type: String,
      default: ''
    },
    yesLabel: {
      type: String,
      default: 'ja'
    },
    noLabel: {
      type: String,
      default: 'nein'
    },
    labelGroupSelection: {
      type: String,
      default: ''
    },
    descriptionGroupSelection: {
      type: String,
      default: ''
    },
    linkToGroupManagement: {
      type: String,
      default: ''
    },
    labelLinkToGroupManagement: {
      type: String,
      default: ''
    },
    newFriendsChecked: {
      type: Boolean,
      default: true
    },
    allFriendsChecked: {
      type: Boolean,
      default: true
    },
    casualFriendsChecked: {
      type: Boolean,
      default: true
    },
    labelAllFriends: {
      type: String,
      default: ''
    },
    labelNewFriends: {
      type: String,
      default: ''
    },
    labelCasualFriends: {
      type: String,
      default: ''
    },
    clusterSelectionLabel: {
      type: String,
      default: ''
    },
    groupOverviewLabel: {
      type: String,
      default: ''
    },
    newFriendsDescription: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      selectedClusterId: null,
      allFriends: false,
      newFriends: false,
      casualFriends: false,
      clusterDefinitions:{}
    }
  },

  computed: {
    selectedClusterObject() {
        if (Array.isArray(this.clusterGroups)) {
          return this.clusterGroups.find(item => item.id == this.selectedClusterId) || null
        }

        if (this.clusterGroups && typeof this.clusterGroups === 'object') {
          return this.clusterGroups[this.selectedClusterId] || []
        }

        return []
    },
  },

  mounted() {
    if (this.cluster.length > 0) {
      this.selectedClusterId = this.cluster[0].id
    }

    this.allFriends = this.allFriendsChecked
    this.newFriends = this.newFriendsChecked
    this.casualFriends = this.casualFriendsChecked
  }
}
</script>